import { Grid } from "@mui/material";
import instutoMonitor from '../assets/imgs/institutoMonitorLogo.png'

export default function ImobCourses() {
    return (
        <>
            {/* ===== Instituto Monitor ===== */}
            <Grid container
                xs={9}
                md={8}
                lg={4.8}
                paddingTop={1}
            >
                <div className="imGrid" >
                    <div className="imCard">
                        <img className="imLogo" src={instutoMonitor} />
                        <div className="dataLandInfo">
                            <h1 className="imH1">
                                Instituto Monitor
                            </h1>
                            <p className="imP">
                                O Instituto Monitor é a escola pioneira no Brasil
                                a desenvolver a Educação a Distância (EAD) como modalidade de estudo.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="gridButton">
                    <div className="imGrid">
                        <Grid item xs={10}
                            style={{
                                marginTop: '1rem',
                                marginLeft: '3.5rem'
                            }}>
                            <a target='_blank' href="https://drive.google.com/file/d/1cWl4vzlLvmpx6iAu3Kqvy8vVIhuFAJVb/view?usp=sharing">
                                <button className='btn btnSecondary'
                                >
                                    Termo de Parceria
                                </button>
                            </a>
                        </Grid>

                        <Grid item xs={2}
                            style={{
                                marginTop: '1rem'
                            }}>
                            <a href="https://portal.institutomonitor.com.br/alunos/" target='_blank'>
                                <button className='btn btnPrimary'
                                >
                                    Acessar
                                </button>
                            </a>
                        </Grid>
                    </div>
                </div>
            </Grid>
            <div style={{
                width: '4rem'
            }}>
            </div>
        </>
    )
}